var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0279 0H20.9369C9.91957 0 0.988281 8.93392 0.988281 19.9545V20.0455C0.988281 31.0661 9.91957 40 20.9369 40H21.0279C32.0452 40 40.9765 31.0661 40.9765 20.0455V19.9545C40.9765 8.93392 32.0452 0 21.0279 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1697 8.1377H14.7963C11.3779 8.1377 8.59692 10.9195 8.59692 14.3389V25.6621C8.59692 29.0815 11.3779 31.8633 14.7963 31.8633H27.1697C30.5881 31.8633 33.3691 29.0815 33.3691 25.6621V14.3389C33.3691 10.9195 30.5881 8.1377 27.1697 8.1377ZM10.7839 14.3389C10.7839 12.1261 12.5841 10.3253 14.7963 10.3253H27.1697C29.3819 10.3253 31.1822 12.1261 31.1822 14.3389V25.6621C31.1822 27.8749 29.3819 29.6757 27.1697 29.6757H14.7963C12.5841 29.6757 10.7839 27.8749 10.7839 25.6621V14.3389Z",
    fill: "#043873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.983 25.7677C24.1618 25.7677 26.7494 23.1807 26.7494 19.9996C26.7494 16.8184 24.1632 14.2314 20.983 14.2314C17.8028 14.2314 15.2166 16.8184 15.2166 19.9996C15.2166 23.1807 17.8028 25.7677 20.983 25.7677ZM20.983 16.4204C22.957 16.4204 24.5625 18.0264 24.5625 20.001C24.5625 21.9755 22.957 23.5815 20.983 23.5815C19.009 23.5815 17.4035 21.9755 17.4035 20.001C17.4035 18.0264 19.009 16.4204 20.983 16.4204Z",
    fill: "#043873"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2832 15.1635C28.1392 15.1635 28.8369 14.467 28.8369 13.6093C28.8369 12.7517 28.1406 12.0552 27.2832 12.0552C26.4258 12.0552 25.7295 12.7517 25.7295 13.6093C25.7295 14.467 26.4258 15.1635 27.2832 15.1635Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.1f7e7c611ab789f02f6d1b198e5e4576.svg";
export { ForwardRef as ReactComponent };